import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { t } from '../i18n/nl.js';

export default function UnauthorizedPage() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate('/login');
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--color-bg)',
      padding: 20,
    }}>
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🚫</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 12 }}>{t('unauthorized.title')}</h1>
        <p style={{ color: 'var(--color-text-muted)', marginBottom: 28, lineHeight: 1.6 }}>
          {t('unauthorized.body')}
        </p>
        <button className="btn btn-ghost" onClick={handleSignOut}>
          {t('unauthorized.uitloggen')}
        </button>
      </div>
    </div>
  );
}
